import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinmumbai() {



    const cardData = {




keyword: "Corporate Cab Services in Mumbai",

headingDescription: "Shreesha Tours & Travels provides professional Corporate Cab Services in Mumbai for businesses, IT companies, multinational corporations, startups, financial institutions, manufacturing units, hotels, and event organizers. We offer employee transportation, executive travel, airport transfers, client pickup and drop, business meeting transfers, conference transportation, long-term corporate cab contracts, and outstation business travel with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Toyota Hycross, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for executives, employees, management teams, and corporate groups. With punctual pickups, professional drivers, transparent billing, GST invoices, flexible corporate packages, dedicated account management, and 24/7 customer support, Shreesha Tours & Travels ensures safe, comfortable, and reliable transportation for every business requirement. Whether you require daily employee commute, airport transfers for VIP guests, intercity business travel, corporate event transportation, or executive chauffeur services, our Mumbai corporate cab service delivers exceptional reliability, comfort, and professionalism.",

topPlaces: [
  {
    title: "Pune",
    description: "Pune is one of the busiest corporate travel destinations from Mumbai, home to Hinjawadi IT Park, Magarpatta City, Kharadi EON IT Park, Talawade IT Park, and numerous multinational companies. Business executives frequently travel between Mumbai and Pune for meetings, conferences, and corporate events."
  },
  {
    title: "Nashik",
    description: "Nashik is a major industrial and manufacturing hub with MIDC estates, wineries, pharmaceutical companies, and engineering industries. Corporate professionals regularly visit Nashik for factory visits, client meetings, and business operations."
  },
  {
    title: "Surat",
    description: "Surat is India's diamond and textile capital, attracting business travelers for corporate meetings, industrial visits, textile markets, and commercial activities throughout the year."
  },
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital with major business parks, manufacturing industries, pharmaceutical companies, and corporate headquarters, making it a preferred destination for executive travel."
  },
  {
    title: "Vadodara",
    description: "Vadodara is an important industrial city with petrochemical industries, engineering companies, and corporate offices. It is a popular destination for business travel from Mumbai."
  },
  {
    title: "Vapi",
    description: "Vapi is one of India's largest industrial hubs, housing chemical, pharmaceutical, textile, and manufacturing companies. Corporate cab services are frequently booked for employee transportation and business visits."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a major manufacturing and industrial city with automobile companies, MIDC industrial areas, and growing business infrastructure, making it a common corporate travel destination."
  },
  {
    title: "Goa",
    description: "Goa is a preferred destination for corporate offsites, annual meetings, incentive tours, conferences, and team-building events. Many organizations book corporate cabs from Mumbai to Goa for business travel."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT and startup hub, attracting business executives for corporate meetings, technology conferences, client visits, and software industry events."
  },
  {
    title: "Hyderabad",
    description: "Hyderabad is a major technology and pharmaceutical hub with HITEC City, Financial District, and multinational companies, making it one of the most important corporate travel destinations from Mumbai."
  }
],



"services": [
  {
    "name": "Corporate Cab Services in Mumbai",
    "description": "Book Corporate Cab Services in Mumbai for reliable employee transportation, executive travel, client meetings, airport transfers, and business travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUVs, and premium cars with flexible daily, monthly, and long-term corporate transportation solutions tailored for companies of all sizes."
  },
  {
    "name": "Mumbai Corporate Cab Service",
    "description": "Choose Mumbai Corporate Cab Service for dependable office transportation with punctual drivers, premium vehicles, and affordable corporate packages. Enjoy seamless travel for executives, employees, corporate events, conferences, business meetings, and outstation business trips with customized travel plans."
  },
  {
    "name": "Corporate Taxi Service Mumbai",
    "description": "Hire Corporate Taxi Service Mumbai for comfortable business travel with experienced chauffeurs, transparent billing, and professionally maintained vehicles. Ideal for employee pickup and drop, executive travel, airport transfers, client visits, and official company transportation."
  },
  {
    "name": "Corporate Car Rental Mumbai",
    "description": "Reserve Corporate Car Rental Mumbai with chauffeur-driven vehicles for daily office commuting, executive transportation, business tours, and corporate events. Select from premium Sedans, Innova Crysta, SUVs, and luxury vehicles with flexible rental options."
  },
  {
    "name": "Employee Transport Service Mumbai",
    "description": "Book Employee Transport Service Mumbai for safe, punctual, and efficient staff transportation with professional drivers and GPS-enabled vehicles. Ensure timely office pickup and drop services for employees with customized routes and flexible scheduling."
  },
  {
    "name": "Office Cab Service Mumbai",
    "description": "Choose Office Cab Service Mumbai for reliable daily employee commuting with comfortable AC vehicles, experienced chauffeurs, and timely pickups. Suitable for IT companies, corporate offices, BPOs, financial institutions, and business organizations."
  },
  {
    "name": "Business Cab Service Mumbai",
    "description": "Hire Business Cab Service Mumbai for executive travel, client meetings, conferences, hotel transfers, and business events with premium chauffeur-driven vehicles. Experience professional service, punctuality, and complete travel convenience."
  },
  {
    "name": "Corporate Airport Transfer Mumbai",
    "description": "Book Corporate Airport Transfer Mumbai for timely airport pickup and drop services for executives, business guests, employees, and corporate clients. Enjoy flight tracking, professional chauffeurs, luxury vehicles, and reliable transportation to and from Mumbai Airport."
  },
  {
    "name": "Company Cab Booking Mumbai",
    "description": "Complete Company Cab Booking Mumbai with customized transportation solutions for offices, factories, IT parks, and corporate organizations. Enjoy dedicated vehicles, experienced drivers, affordable pricing, and flexible corporate booking plans."
  },
  {
    "name": "Corporate Travel Service Mumbai",
    "description": "Choose Corporate Travel Service Mumbai for professional business transportation with premium vehicles, trained chauffeurs, and customized travel management solutions. Perfect for meetings, conferences, employee travel, airport transfers, and outstation business tours."
  },
  {
    "name": "Staff Transportation Service Mumbai",
    "description": "Book Staff Transportation Service Mumbai for secure and comfortable employee commuting with well-maintained AC vehicles and professional drivers. Benefit from scheduled pickups, optimized routes, reliable service, and affordable corporate transportation packages."
  },
  {
    "name": "Corporate Fleet Service Mumbai",
    "description": "Hire Corporate Fleet Service Mumbai for dedicated company transportation with a fleet of Sedans, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and executive vehicles. Ideal for employee transportation, business events, VIP guests, and large-scale corporate mobility requirements."
  },
  {
    "name": "Monthly Cab Rental Mumbai",
    "description": "Choose Monthly Cab Rental Mumbai for long-term chauffeur-driven transportation with cost-effective corporate plans, dedicated drivers, and premium vehicles. Perfect for office commuting, executive travel, employee transportation, airport transfers, and recurring business travel with flexible monthly rental packages."
  }
],
"tableData": [
  ["Corporate Cab Services in Mumbai", "Mumbai Corporate Cab Service"],
  ["Corporate Taxi Service Mumbai", "Corporate Car Rental Mumbai"],
  ["Employee Transport Service Mumbai", "Office Cab Service Mumbai"],
  ["Business Cab Service Mumbai", "Corporate Airport Transfer Mumbai"],
  ["Company Cab Booking Mumbai", "Corporate Travel Service Mumbai"],
  ["Staff Transportation Service Mumbai", "Corporate Fleet Service Mumbai"],
  ["Monthly Cab Rental Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Professional Corporate Cab Services in Mumbai",
    WhyChoosedescription: "Shreesha Tours & Travels offers dependable corporate cab services in Mumbai for businesses, IT companies, MNCs, startups, and professionals seeking comfortable, punctual, and efficient transportation solutions."
  },
  {
    WhyChooseheading: "Business Travel Tailored to Your Company's Needs",
    WhyChoosedescription: "From daily employee transportation to executive travel, client meetings, conferences, airport transfers, and corporate events, our cab services are designed to support every business requirement."
  },
  {
    WhyChooseheading: "Extensive Fleet for Executives & Corporate Teams",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses for individual executives and large corporate groups."
  },
  {
    WhyChooseheading: "Reliable Airport Transfers for Business Professionals",
    WhyChoosedescription: "Ensure timely airport pickups and drop-offs for employees, clients, business delegates, and VIP guests with our professionally managed corporate airport transfer services."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs with Professional Etiquette",
    WhyChoosedescription: "Our trained drivers maintain punctuality, courteous behaviour, safe driving practices, and confidentiality, making them ideal for corporate travel requirements."
  },
  {
    WhyChooseheading: "Flexible Corporate Travel Packages",
    WhyChoosedescription: "Book hourly rentals, daily employee transport, monthly corporate contracts, executive travel, one-way trips, round trips, conference transportation, and customized business travel solutions."
  },
  {
    WhyChooseheading: "Comfortable, Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, air-conditioned, and maintained to provide executives and employees with a comfortable travel experience throughout the journey."
  },
  {
    WhyChooseheading: "Trusted Corporate Mobility Partner",
    WhyChoosedescription: "With transparent pricing, dedicated account support, and reliable service standards, Shreesha Tours & Travels is a preferred choice for corporate cab services across Mumbai."
  }
]

};

const faqData = [
  {
    question: "What corporate transportation services do you provide in Mumbai?",
    answer: "We provide employee transportation, executive travel, airport transfers, client pickups, conference travel, corporate events, and business meeting transportation."
  },
  {
    question: "Can companies book cabs on a monthly contract basis?",
    answer: "Yes, monthly corporate transportation contracts and long-term business travel solutions are available."
  },
  {
    question: "Which vehicles are available for corporate travel?",
    answer: "Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses are available."
  },
  {
    question: "Do you provide airport transfers for business executives?",
    answer: "Yes, we offer professional airport pickup and drop services for executives, employees, clients, and international delegates."
  },
  {
    question: "Can I arrange transportation for corporate events and conferences?",
    answer: "Yes, transportation can be arranged for conferences, seminars, exhibitions, meetings, team outings, and corporate events."
  },
  {
    question: "Are your chauffeurs trained for corporate travel?",
    answer: "Yes, our drivers are professional, punctual, courteous, and experienced in handling executive and business transportation."
  },
  {
    question: "Do you offer employee pickup and drop services?",
    answer: "Yes, we provide daily employee transportation with flexible schedules for offices, business parks, and corporate campuses."
  },
  {
    question: "Can large corporate groups book Tempo Travellers?",
    answer: "Yes, Tempo Travellers and Mini Buses are available for corporate teams, group travel, and company outings."
  },
  {
    question: "How is the corporate cab pricing determined?",
    answer: "Pricing depends on the selected vehicle, travel schedule, contract duration, trip frequency, and transportation requirements."
  },
  {
    question: "How can I book Corporate Cab Services in Mumbai with Shreesha Tours & Travels?",
    answer: "Simply share your company requirements, travel schedule, pickup locations, destination details, passenger count, and preferred vehicle to receive a customized corporate transportation proposal."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Khanna",
    feedback: "Our company has been using Shreesha Tours & Travels for executive airport transfers and client meetings. Their punctuality, clean vehicles, and professional drivers have consistently impressed our team.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Ritu Sharma",
    feedback: "We arranged transportation for a corporate event through Shreesha Tours & Travels. Multiple vehicles arrived on time, the coordination was excellent, and the service exceeded our expectations.",
    rating: 5
  }
];
















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/corporate-cab-services-in-mumbai.webp",
  "description":
    "Book Corporate Cab Services in Mumbai with Shreesha Tours & Travels for safe, professional, and affordable business transportation. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for employee transportation, airport transfers, client meetings, executive travel, office commutes, corporate events, and long-term business travel solutions.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/corporate-cab-services-in-mumbai"
  }
};








    return (
        <div>
<Helmet>
  <title>Corporate Cab Services in Mumbai | Business Travel Cabs | +91 8355835813</title>

  <meta
    name="description"
    content="Book Corporate Cab Services in Mumbai with Shreesha Travels for reliable employee transport, executive travel, airport transfers, and office cab services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Corporate Cab Services in Mumbai, Mumbai Corporate Cab Service, Corporate Taxi Service Mumbai, Corporate Car Rental Mumbai, Employee Transport Service Mumbai, Office Cab Service Mumbai, Executive Cab Service Mumbai, Business Travel Cab Mumbai, Corporate Airport Transfer Mumbai, Company Cab Service Mumbai, Corporate Outstation Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabserviceinmumbai;